import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUpWall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowUpWall"><Path d="M20 21H4V19H20V21Z" fill="currentColor"/><Path d="M17.6641 8L16.25 9.41406L13 6.16406V17H11V6.16406L7.75 9.41406L6.33594 8L12 2.33594L17.6641 8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowUpWall;
